import React, { useState, Children, useEffect } from 'react';
import PropTypes from 'prop-types';
import { GetScope, useToken22 } from '../features/authentication/hooks/useToken';
import { useDispatch, useSelector } from 'react-redux';
import { setSessionExpired } from '../features/authentication/authSlice';
import { useTranslation } from 'react-i18next';
import { useClientUser } from '../providers/client.provider';
import { Box, Tooltip, useTheme, useTheme as useThemeMui } from '@mui/material';
import AccountMenu from '../pages/accountMenu';
import AutoComplete from '../components/autocomplete';
import CustomerNav from '../pages/customers/customerNav';
import SearhAssociate from './searhAssociate';
import Modal from '../components/modal';
import BreadcrumbComponent from './breadcrumb';
import { IoCloseSharp } from 'react-icons/io5';
import { AllowByAssociateTypes } from './permission';
import { useNavigate } from 'react-router-dom';
import { isAdmin } from '../util/flags';
import ThemeToggle from './ThemeToggle';
import { FiSidebar } from 'react-icons/fi';
import { toggleSidebar } from '../slices/uiSlice';
import { useThemeMode } from '../contexts/ThemeContext';

// Page Header components
const PageHeader = ({
  Icon,
  preTitle,
  title,
  postTitle,
  children,
  breadcrumbs,
  onSearch,
  customerId,
  pageId,
  rightHeader,
  headerClassName,
}) => {
  const [searchText, setSearchText] = useState('');
  const [showCustomerList, setShowCustomerList] = useState(true);
  const [searchBox, setSearchBox] = useState(false);
  const { clientUser } = useClientUser();
  const themeMui = useThemeMui();
  const theme = useTheme();
  const apiToken = localStorage.getItem('apiToken');
  const nav = useNavigate();
  const clientUserRole = JSON.parse(apiToken)?.userRole || clientUser?.userRole;
  let header;
  let content = [];

  const { clearToken } = useToken22();

  const { t } = useTranslation();
  const { mode, toggleColorMode } = useThemeMode();

  const dispatch = useDispatch();
  const sessionExpired = useSelector((state) => state.auth.sessionExpired);
  const sidebarExpanded = useSelector((state) => state.ui.sidebarExpanded);
  const [isMobileDevice, setIsMobileDevice] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileDevice(window.innerWidth < 992);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  Children.forEach(children, (child) => {
    if (!React.isValidElement(child)) return;
    if (child.type === CardHeader) {
      header = child;
    } else {
      content.push(child);
    }
  });

  //LOGIN AGAIN
  const handleLoginAgain = () => {
    dispatch(setSessionExpired(false));
    localStorage.removeItem('apiToken');
    clearToken();
    location = '/';
    const currentPath = window.location.pathname + window.location.search;

    // const apiToken = JSON.parse(localStorage.getItem("apiToken"))
    const role = clientUserRole;
    const associate = JSON.parse(apiToken)?.associateId;
    let deepLink = {
      currentPath: currentPath,
      role: role,
      associateId: associate,
    };
    sessionStorage.setItem('deepLink', JSON.stringify(deepLink));
  };

  // const handleCloseModal = () => {
  //   dispatch(setSessionExpired(false));
  // };

  // Handle Change function
  const handleChange = (name, value) => {
    setSearchText(value);
    if (onSearch == undefined) {
      window.location.href = `/customers/${value}/${isAdmin() ? 'summary' : 'user-summary'}`;
    } else {
      onSearch(value);
      // location = `/customers/${value}/summary`;
      setSearchText();
    }
  };

  // Handle Submit function
  const handleSubmit = async (e) => {
    e.preventDefault();
    alert(searchText);
    onSearch(searchText);
  };

  // Search Function
  const fnSearch = () => {
    setSearchBox(true);
    setShowCustomerList(true);
  };

  // Hide Search Funcion
  const fnHideSearch = () => {
    setSearchBox(false);
  };

  // Get Navigation Function
  const GetNav = () => {
    if (clientUserRole == 'ClientUser') {
      return <div></div>;
    } else {
      return <CustomerNav customerId={customerId} pageId={pageId} />;
    }
  };

  return (
    <>
      <Box
        variant='header'
        className={`navbar navbar-sticky navbar-expand-md d-flex d-none d-md-flex d-print-none mui-mode-${themeMui.palette.mode || 'light'}`}
        sx={{
          height: '58px',
          backgroundColor: theme.palette.background.paper,
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <div className='container-xl'>
          <button
            className='navbar-toggler d-none'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbar-menu'
          >
            <span className='navbar-toggler-icon'></span>
          </button>
          {/* {!isMobileDevice && (
            <Tooltip title={t('toggleSidebar')} placement='top'>
              <div className='nav-item dropdown top-nav ml-05rem'>
                <label className='circle-checkbox cursor-pointer'>
                  <FiSidebar
                    size={22}
                    color={mode === 'dark' ? '#ffffffff' : '#0f0f0fe5'}
                  />
                  <input
                    type='checkbox'
                    checked={sidebarExpanded}
                    onChange={() => dispatch(toggleSidebar())}
                  />
                </label>
              </div>
            </Tooltip>
          )} */}
          <div className='navbar-nav flex-row order-md-last d-flex m-1'>
            <div className='nav-item dropdown top-nav pb-7'>
              <ThemeToggle useLabel={false} />
            </div>
          </div>
          {isMobileDevice ? null : (
            <div className='navbar-nav flex-row order-md-last d-flex'>
              <div className='nav-item dropdown top-nav'>
                <AccountMenu />
              </div>
            </div>
          )}

          {/* CustomerNav for smaller screens */}
          {customerId && (
            <div className='d-none w-100'>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  maxWidth: '980px', // Adjust as needed
                  marginLeft: '20px',
                  marginRight: '20px',
                  overflowX: 'scroll',

                  // border: "1px solid #ddd", // Optional for visual separation
                }}
              >
                {customerId && <CustomerNav customerId={customerId} pageId={pageId} />}
              </div>
            </div>
          )}
          <div className='flex-row justify-content-center w-100'>
            <div className='ms-auto me-auto' style={{ maxWidth: '600px' }}>
              <div
                className={`collapse navbar-collapse  cus-nav  ${
                  GetScope() == undefined && customerId ? '' : ' justify-content-center '
                }`}
                id='navbar-menu'
              >
                <div className='d-none d-lg-flex'>{/* {customerId && <GetNav />} */}</div>

                <div
                  className={
                    GetScope() == undefined && customerId
                      ? 'ms-auto me-3 w-50 d-none d-lg-flex'
                      : 'w-50 d-none d-lg-flex '
                  }
                >
                  <form onSubmit={handleSubmit} autoComplete='off'>
                    <div className='input-icon search-icn-dv '>
                      <button
                        type='button'
                        className='btn-icn'
                        onClick={() => {
                          fnHideSearch();
                          setShowCustomerList(false);
                        }}
                      >
                        {/* FOR HIDDEN TOGGEL SEARCH BAR */}
                        {/* {searchBox == false ? (
                      ''
                    ) : (
                      <IoCloseSharp size={20} color={theme.palette.text.primary} />
                    )} */}
                      </button>
                    </div>
                    <div
                      id='search-div'
                      onClick={fnSearch}
                      // style={{ width: searchBox ? '95%' : '60px' }}
                      style={{ width: '95%' }}
                    >
                      <AllowByAssociateTypes allowedTypes={['affiliate']}>
                        {clientUserRole === 'ClientUser' ? (
                          <AutoComplete
                            name='search'
                            placeholder='Search Team Members'
                            value={searchText}
                            showIcon={true}
                            onChange={handleChange}
                          />
                        ) : (
                          <SearhAssociate
                            showIcon={true}
                            onChange={handleChange}
                            showCustomerList={showCustomerList}
                            setShowCustomerList={setShowCustomerList}
                          />
                        )}
                      </AllowByAssociateTypes>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>
      <div
        className={`page-wrapper ${pageId} ps-2 mui-mode-${themeMui.palette.mode || 'light'}`}
      >
        {title && (
          <div className='container-xl'>
            <div className='page-header d-print-none'>
              <div
                className='row g-3 align-items-center'
                style={{ position: 'relative' }}
              >
                <div className='col me-4 ass-hdr'>
                  {breadcrumbs && <BreadcrumbComponent breadcrumbs={breadcrumbs} />}
                  {preTitle && (
                    <div
                      className='page-pretitle trns d-flex align-items-center'
                      data-trans={preTitle.toLowerCase().replace(/[^\d\w]/gi, '')}
                    >
                      {Icon && (
                        <span className='nav-link-icon me-1 d-md-none d-lg-inline-flex align-items-center page-header-icon'>
                          {Icon}
                        </span>
                      )}
                      <span className='nav-link-title '>{preTitle}</span>
                    </div>
                  )}
                  <h2 className={`page-title  text-break text-truncate`}>
                    {!preTitle && <span>{Icon}</span>}
                    <span className='text-wrap'>{title}</span>
                  </h2>
                  {postTitle && (
                    <div
                      className='page-pretitle trns'
                      data-trans={postTitle.toLowerCase().replace(/[^\d\w]/gi, '')}
                    >
                      {postTitle}
                    </div>
                  )}
                </div>
                <div className={headerClassName || 'col-auto ms-auto d-print-none'}>
                  {!!header && <header>{header}</header>}
                </div>
                {rightHeader && (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      position: 'absolute',
                      right: 0,
                    }}
                    className='right-header'
                  >
                    {rightHeader}
                  </Box>
                )}
              </div>
            </div>
          </div>
        )}
        <div className={`page-body h-100 mui-mode-${themeMui.palette.mode || 'light'}`}>
          {content}
        </div>

        {/* <Modal showModal={sessionExpired} size="sm" disableClose={true}>
          <div className="card"
            style={{
              // height: "180px",
              // padding: "1rem",
              display: "flex",
              flexDirection: "column",
              // justifyContent: "center",
            }}
          >
            <div className="card-header"
              style={{
                // flex: 1,
                display: "flex",
                alignItems: "center",
                // justifyContent: "center",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 24 24"
                style={{
                  // marginRight: "0.75rem",
                  color: "black", // Branded primary color
                }}
              >
                <path d="M12 1a7 7 0 00-7 7v4H4v11h16V12h-1V8a7 7 0 00-7-7zm0 2a5 5 0 015 5v4H7V8a5 5 0 015-5zm-1 9h2v4h-2v-4zm0 6h2v2h-2v-2z" />
              </svg>
              <h3>{t("yourSessionExpired")}</h3>
            </div>
            <div className="card-body">
              <h4>{t("forYourSecurity")}</h4>
            </div>
            <div className="mb-2" style={{ display: "flex", justifyContent: "space-around" }}>
              <button className="btn btn-primary" onClick={handleLoginAgain}>
                {t("signBackIn")}
              </button>
            </div>
          </div>
        </Modal> */}

        <Modal showModal={sessionExpired} size='sm' disableClose={true}>
          <div
            className='session-expired-modal'
            style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              // padding: "2rem",
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
              animation: 'fadeInUp 0.4s ease-out',
              maxWidth: '400px',
              width: '100%',
              margin: '0 auto',
            }}
          >
            <div
              className='modal-header'
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                // marginBottom: "1rem",
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                style={{ marginRight: '0.75rem', color: 'black' }}
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
                className='icon-tabler icons-tabler-outline icon-tabler-lock-exclamation'
              >
                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                <path d='M15 21h-8a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.734 1.002' />
                <path d='M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0' />
                <path d='M8 11v-4a4 4 0 1 1 8 0v4' />
                <path d='M19 16v3' />
                <path d='M19 22v.01' />
              </svg>

              <h3 className='modal-title m-0'>{t('yourSessionExpired')}</h3>
            </div>

            <div className='modal-body' style={{ marginBottom: '0rem' }}>
              <p style={{ fontSize: '16px', color: '#555' }}>{t('forYourSecurity')}</p>
            </div>

            <div
              className='modal-footer'
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <button
                className='btn btn-primary'
                onClick={handleLoginAgain}
                style={{ borderRadius: '6px', padding: '0.5rem 1.25rem' }}
              >
                {t('signBackIn')}
              </button>
            </div>
          </div>
        </Modal>
      </div>
      {/* </header>
    <div className={`page-wrapper ${pageId}`}>
      {title && <div className="container-xl">
        <div className="page-header d-print-none">
          <div className="row g-3 align-items-center">
            <div className="col me-4 ass-hdr">
              {breadcrumbs && <>
                <ol className="breadcrumb breadcrumb-arrows" aria-label="breadcrumbs">
                  {breadcrumbs.map((crumb) => {
                    return <li key={crumb.link} className="breadcrumb-item">
                      <a href={crumb.link}>{crumb.title}</a>
                    </li>
                  })}

                </ol>
              </>}
              {preTitle && <div className="page-pretitle">
                {preTitle}
              </div>}
              <h2 className="page-title  text-break text-truncate">
                <span className="text-wrap">{title}</span>
              </h2>
              {postTitle && <div className="page-pretitle">
                {postTitle}
              </div>}
            </div>
            <div className="col-auto ms-auto d-print-none">
              {!!header && <header>{header}</header>}
            </div>
          </div>
        </div>
      </div>}
      <div className="page-body h-100">
        {content}
      </div>
 
      <Modal showModal={sessionExpired} size="sm" disableClose={true}>
        <div style={{ height: '180px', padding: '1rem', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h2>Session expired</h2>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <button className='btn btn-primary' onClick={handleLoginAgain}>Login Again</button>
          </div>
        </div>
      </Modal>
    </div>
  </>
} */}
    </>
  );
};

function CardHeader({ className, children }) {
  return <header className={className || ''}>{children}</header>;
}
CardHeader.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
};

export default PageHeader;
export { CardHeader };

CardHeader.propTypes = {
  children: PropTypes.any,
};

PageHeader.propTypes = {
  Icon: PropTypes.element,
  preTitle: PropTypes.string,
  title: PropTypes.string,
  postTitle: PropTypes.string,
  children: PropTypes.any.isRequired,
  onSearch: PropTypes.func,
  breadcrumbs: PropTypes.any,
  customerId: PropTypes.string,
  pageId: PropTypes.string,
  rightHeader: PropTypes.any,
  headerClassName: PropTypes.string,
};
